import {
	POST_DRIVING_EXTRA_ACTIVITY_OPTIONS,
	PRE_DRIVING_EXTRA_ACTIVITY_OPTIONS,
	getExtraActivityLocationOptions,
} from 'common/ActivityChip/utils/extraActivities';
import { minutesToDuration as minutesToDurationBase } from 'utils/datetime';

import { DEFAULT_EXTRA_ACTIVITY_DURATION } from './const';
import { MANAGE_EXTRA_ACTIVITY_TEXT } from './text';

export const minutesToDuration = (durationMinutes) => {
	const totalMinutes = Number(durationMinutes);

	if (!Number.isFinite(totalMinutes) || totalMinutes <= 0) {
		return DEFAULT_EXTRA_ACTIVITY_DURATION;
	}

	return minutesToDurationBase(totalMinutes);
};

export const getActivityLocationMismatchError = (activityType, stationId, locations = []) => {
	const locationOptions = getExtraActivityLocationOptions(locations);
	const firstLocation = locationOptions[0];
	const lastLocation = locationOptions[locationOptions.length - 1];

	if (stationId === firstLocation?.id) {
		return MANAGE_EXTRA_ACTIVITY_TEXT.activityOnlyAtLastStationError;
	}
	if (stationId === lastLocation?.id) {
		return MANAGE_EXTRA_ACTIVITY_TEXT.activityOnlyAtFirstStationError;
	}

	const isBeforeDrivingActivity = PRE_DRIVING_EXTRA_ACTIVITY_OPTIONS.some(
		({ type }) => type === activityType
	);
	const isAfterDrivingActivity = POST_DRIVING_EXTRA_ACTIVITY_OPTIONS.some(
		({ type }) => type === activityType
	);

	if (isBeforeDrivingActivity && !isAfterDrivingActivity) {
		return MANAGE_EXTRA_ACTIVITY_TEXT.activityOnlyAtFirstStationError;
	}

	if (isAfterDrivingActivity && !isBeforeDrivingActivity) {
		return MANAGE_EXTRA_ACTIVITY_TEXT.activityOnlyAtLastStationError;
	}

	return MANAGE_EXTRA_ACTIVITY_TEXT.activityOnlyAtLastStationError;
};
